import api from "@/api";

export default class BatchInfo {
  constructor(rawdata = {}) {
    this.id = rawdata.id ? rawdata.id : 0;
    this.invoice_no = rawdata.invoice_no ? rawdata.invoice_no : "";
    this.batch_no = rawdata.batch_no ? rawdata.batch_no : "";
    this.customs_duty = rawdata.customs_duty ? rawdata.customs_duty : "";
    this.freight_cost = rawdata.freight_cost ? rawdata.freight_cost : "";
    this.bank_expenses = rawdata.bank_expenses ? rawdata.bank_expenses : "";
    this.percentage = rawdata.percentage ? rawdata.percentage : "";
    this.customs_duty_foreign = rawdata.customs_duty_foreign
      ? rawdata.customs_duty_foreign
      : "";
    this.freight_cost_foreign = rawdata.freight_cost_foreign
      ? rawdata.freight_cost_foreign
      : "";
    this.bank_expenses_foreign = rawdata.bank_expenses_foreign
      ? rawdata.bank_expenses_foreign
      : "";
    this.percentage_foreign = rawdata.percentage_foreign
      ? rawdata.percentage_foreign
      : "";
  }

  static async fetchAvailableItems(po_id) {
    const result = await api.get(`/api/v1/inventory/available/?po_id=${po_id}`);
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async create(payload) {
    const result = await api.post(
      `/api/v1/inventory/stockin/`,
      payload,
      "json"
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async fetch(batch_id) {
    const result = await api.get(
      `/api/v1/inventory/list/?batch_id=${batch_id}`
    );
    if (result && result.status == 200) {
      let data = result.data.data[0];
      return data;
    }

    return null;
  }

  static rules() {
    return {
      customs_duty: [
        {
          required: true,
          message: "Customs duty is required.",
          trigger: "blur"
        },
        {
          min: 0,
          type: "number",
          message: "Customs duty should be a positive value.",
          trigger: "blur"
        }
      ],
      freight_cost: [
        {
          required: true,
          message: "Freight cost is required.",
          trigger: "blur"
        },
        {
          min: 0,
          type: "number",
          message: "Freight cost should be a positive value.",
          trigger: "blur"
        }
      ],
      bank_expenses: [
        {
          required: true,
          message: "Bank expenses is required.",
          trigger: "blur"
        },
        {
          type: "number",
          min: 0,
          message: "Bank expenses should be a positive value.",
          trigger: "blur"
        }
      ]
    };
  }
}
